import Hero from "../components/Hero";
import OccasionStrip from "../components/OccasionStrip";
import FeaturedManaged from "../components/FeaturedManaged";
import MarketplacePreview from "../components/MarketplacePreview";
import WhyAppy from "../components/WhyAppy";
import ManagedPitch from "../components/ManagedPitch";
import EventsBanner from "../components/EventsBanner";
import TestimonialsMarquee from "../components/TestimonialsMarquee";
import OwnerStrip from "../components/OwnerStrip";
import AboutMini from "../components/AboutMini";
import FinalCTA from "../components/FinalCTA";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#FAFAF8]">
      <Hero />
      <OccasionStrip />
      <FeaturedManaged />
      <MarketplacePreview />
      <WhyAppy />
      <ManagedPitch />
      <EventsBanner />
      <TestimonialsMarquee />
      <OwnerStrip />
      <AboutMini />
      <FinalCTA />
    </main>
  );
}
